<template>
	<div class="header-bag">
		<div class="common_header">
			<div v-if="accountType === 'student'" class="header_left">
				<router-link to="/home">
				  <span class="spana">
					<i class="iconfont">&#xe626;</i>
				  </span>
				</router-link>
				<span class="spanb" @click="GoBack">
				  <i class="iconfont">&#xe629;</i>
				</span>
			</div>
			<div v-if="accountType === 'sys'" class="header_left">
				  <span class="spana">
					<i class="iconfont">&#xe626;</i>
				  </span>
			</div>
			<div class="header_right">
				<template v-if="accountType === 'sys'">
					<div class="nav_sys">
						<router-link to="/sys/unit">
							<span class="span_sys">合作单位</span>
						</router-link>
					</div>
					<div class="nav_sys">
						<router-link to="/sys/staff">
							<span class="span_sys">员工列表</span>
						</router-link>
					</div>
					<div class="nav_sys">
						<router-link to="/sys/report">
							<span class="span_sys">功能报表</span>
						</router-link>
					</div>
				</template>

				<template v-if="accountType === 'student'">
					<div class="nav">
						<el-popover
							ref="secret"
							placement="bottom"
							width="220"
							popper-class="secret_popover"
							trigger="hover"
						>
							<div class="img">
								<div class="imgs">
									<div class="title">微信扫一扫关注提分案例/提分秘籍</div>
									<img class="images" src="../../../src/assets/images/rwm1.png" />
								</div>
							</div>
						</el-popover>
						<span v-popover:secret class="span1">提分秘籍</span>
					</div>
					<div class="nav1">
						<el-popover
							ref="parentQr"
							placement="bottom"
							width="220"
							popper-class="parentQr_popover"
							trigger="hover"
						>
							<div class="img">
								<div class="imgs">
									<div class="title">请使用微信扫一扫</div>
									<img class="images" :src="stuInfoData.qrCodeUrl ? stuInfoData.qrCodeUrl : '../../../src/assets/images/rwm2.png'" />
								</div>
							</div>
						</el-popover>
						<span v-popover:parentQr class="span2">家长端</span>
					</div>
					<div class="nav2">
						<router-link to="WebRTC">
							<span class="span3">视频辅导</span>
						</router-link>
					</div>
					<div class="nav2">
						<router-link to="purchaseRecord">
							<span class="span3">购买记录</span>
						</router-link>
					</div>
				</template>

				<div class="nav3">
					<router-link to="changePassword">
						<span class="span4">修改密码</span>
					</router-link>
				</div>
				<div class="nav4">
					<span class="span5" @click="LoginOut">退出</span>
				</div>
				<div class="nav5">
					<i v-popover:signIn  class="iconfont head">&#xe628;</i>
					<el-popover
						popper-class="sign_popover"
						placement="bottom"
						width="180"
						trigger="hover"
						ref="signIn"
					>
						<div class="signs">
							<div class="sign_title">{{stuInfoData.studentName ? stuInfoData.studentName : ''}}</div>
							<div v-if="accountType === 'student'" class="sign_title" style="padding-top: 5px">剩余时间：{{stuInfoData.remainTimeStr}}</div>
							<div v-if="accountType === 'student'" class="sign_content">
								<div class="sign_content_number" :title="stuInfoData.goldNum ?  ('当前积分：'+ stuInfoData.goldNum) : 0">
									<div class="money">
										<img class="img" src="../../../src/assets/images/jb.png" />
									</div>
									<div class="click">{{ stuInfoData.goldNum ?  stuInfoData.goldNum : 0}}</div>
								</div>
							</div>
						</div>
					</el-popover>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import api from "../../axios/interface";
	import {removeUserInfo, isLogin} from "../../utils/api"
	export default {
		data() {
			return {
				stuInfoData: [],
				visible: false,
				flag: false,
				defaultHead:'https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=3790034832,2705828409&fm=26&gp=0.jpg',
				accountType: ""
			};
		},
		mounted() {
			this.accountType = "";
			if(isLogin()){
				this.getStudentInfo()
				// 读取账号类型
				this.accountType = localStorage.getItem("accountType") || "";
			}
		},
		methods: {
			getStudentInfo() {
				this.$axios.get(api.GetStudentInfo, {}, { hideMessage: true })
					.then(res => {
						this.stuInfoData = res.result
					})
					.catch(res => {});
			},

			signIn: function() {
				let that = this;
				if(!this.stuInfoData.isSingInFlag){
					this.$axios.get(api.GetStudentSignin, {}, { hideMessage: true })
						.then(res => {
							that.$message({
								showClose: true,
								message: '签到成功',
								duration: 1000,
								type: 'success'
							});
							this.getStudentInfo()
						})
						.catch(res => {});
				}else {
					that.$message({
						showClose: true,
						duration: 1000,
						message: '今日已签到，无需再次签到'
					});
				}
			},

			GoBack() {
				this.$router.go(-1);
			},

			LoginOut() {
				this.$axios.get(api.LoginOut,{},
					{
						hideMessage: true
					}
				)
					.then(res => {
						this.$router.push({
							name: "login"
						});
					});
				removeUserInfo()
				localStorage.removeItem("accountType");
				this.accountType = "";
				this.$router.push({
					name: "login"
				});
			}
		}
	};
</script>
<style lang="less" scoped>
	.header-bag {
		width: 100%;
		background: #fff;
	}
	.common_header {
		width: 1200px;
		line-height: 45px;
		display: flex;
		flex-direction: row;
		background-color: #fff;
		margin: 0 auto;
		.header_left {
			width: 100%;
			display: flex;
			padding-left: 40px;
			.spana {
				display: block;
				cursor: pointer;
				i {
					color: #333;
					font-size: 26px;
				}
			}
			.spanb {
				display: block;
				padding-left: 10px;
				cursor: pointer;
				i {
					color: #333;
					font-size: 23px;
				}
			}
		}
		.header_right {
			text-align: center;
			display: flex;
			flex-direction: row;
			font-size: 14px;
			color: #999999;
			margin-right: 110px;
			.span1,
			.span3,
			.span4,
			.span_sys {
				width: 70px;
			}
			.span2 {
				width: 60px;
			}
			.span5 {
				width: 50px;
				color: #999999;
			}
			.span1,
			.span2,
			.span3,
			.span4,
			.span5,
			.span_sys {
				display: inline-block;
				height: 25px;
				line-height: 25px;
				border-radius: 4px;
				border: 1px solid #ffffff;
				margin-right: 12px;
				cursor: pointer;
				&:hover {
					border: 1px solid #999999;
				}
			}
		}
	}

	.signs {
		width: 130px;
		height: 87px;
		margin: 15px;
		.sign_title {
			width: 150px;
			height: 20px;
			text-align: center;
			font-size: 15px;
			color: #9b9b9b;
			margin-top: 10px;
		}
	}
	.sign_content {
		width: 150px;
		height: 30px;
		display: flex;
		flex-direction: row;
		margin-top: 10px;
	}
	.sign_content_number {
		width: 75px;
		height: 30px;
		display: flex;
		flex-direction: row;
		line-height: 30px;
		.img {
			width: 20px;
			height: 20px;
		}
		.money {
			width: 20px;
			margin-top: 5px;
		}
		.click {
			width: auto;
			text-align: center;
			padding-left: 5px;
		}
	}
	.nav5 {
		cursor: pointer;
		i {
			font-size: 24px;
			color: #333;
		}
	}
</style>
<style lang="less">
	.secret_popover,
	.parentQr_popover {
		position: relative;
		padding: 0 !important;
		margin: 0;
		.img {
			background: #f5f5f5;
			.imgs {
				height: 190px;
				width: 220px;
				border-radius: 10px;
				display: flex;
				flex-direction: column;
				align-items: center;
				.title {
					display: inline-block;
					text-align: center;
					color: #4d4d4d;
					font-size: 12px;
					margin: 15px;
				}
				.images {
					width: 110px;
					height: 110px;
					margin-top: 10px;
				}
			}
		}
		.popper__arrow::after {
			border-bottom-color: #f2f2f2 !important;
		}
	}

	.sign_popover {
		position: absolute;
		background-color: #f5f5f5;
		min-width: 150px;
		padding: 12px;
		z-index: 2000;
		color: #606266;
		line-height: 1.4;
		font-size: 14px;
		margin-left: -177px;
	}
</style>
